import * as R from 'ramda';

const alphabet = 'abcdefghijklmnopqrstuvwxyz'.split('');

const extendedAlphabet = alphabet.concat(['CH', 'ZH', 'SH', '#']);
const extendedAlphabetForRewrite = alphabet.concat(['#']);

const groupTermsByAlphabet = (terms: DictionaryTerms) => {
  const result = R.map(
    (char: string) => ({
      char: char.toUpperCase(),
      list: terms[char.toUpperCase()] || [],
    }),
    extendedAlphabet,
  );
  return result;
};

export {
  alphabet,
  extendedAlphabet,
  extendedAlphabetForRewrite,
  groupTermsByAlphabet,
};
